module.exports = __webpack_public_path__ + "img/img_app_guide02.ea24137f.png";